import classNames from "classnames";
import React, { FC } from "react";
import { LuCheck, LuMinus } from "react-icons/lu";

import { CheckboxProps } from "./Checkbox.types";

const CHECKBOX_SIZE_CLASSES = {
  sm: "h-4 w-4 rounded-md",
  md: "h-5 w-5 rounded-md",
};

export const Checkbox: FC<CheckboxProps> = ({
  checked,
  indeterminate,
  disabled,
  presentation,
  ariaLabel,
  size = "sm",
  className,
  iconClassName,
}) => {
  const isActive = checked || indeterminate;

  return (
    <span
      role={presentation ? undefined : "checkbox"}
      aria-hidden={presentation || undefined}
      aria-label={!presentation ? ariaLabel : undefined}
      aria-checked={
        !presentation ? (indeterminate ? "mixed" : !!checked) : undefined
      }
      aria-disabled={!presentation ? disabled || undefined : undefined}
      className={classNames(
        "flex shrink-0 items-center justify-center border",
        CHECKBOX_SIZE_CLASSES[size],
        isActive
          ? "border-[#6B4EFF] bg-[#6B4EFF]"
          : "border-[#C9CDD6] bg-white",
        disabled && "opacity-50",
        className,
      )}>
      {checked && !indeterminate && (
        <LuCheck
          size={size === "md" ? 13 : 12}
          strokeWidth={3}
          className={classNames("text-white", iconClassName)}
        />
      )}
      {indeterminate && (
        <LuMinus
          size={size === "md" ? 13 : 12}
          strokeWidth={3}
          className={classNames("text-white", iconClassName)}
        />
      )}
    </span>
  );
};
